import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class OrbiAnnouncerService {
  private readonly politeText = new BehaviorSubject<string>('');
  private readonly assertiveText = new BehaviorSubject<string>('');

  readonly polite$: Observable<string> = this.politeText.asObservable();

  readonly assertive$: Observable<string> = this.assertiveText.asObservable();

  announce(message: string): void {
    this.write(this.politeText, message);
  }

  alert(message: string): void {
    this.write(this.assertiveText, message);
  }

  clear(): void {
    this.politeText.next('');
    this.assertiveText.next('');
  }

  private write(channel: BehaviorSubject<string>, message: string): void {
    const text = message.trim();
    if (!text) {
      return;
    }
    channel.next('');
    setTimeout(() => channel.next(text));
  }
}
